import { Stack } from '@mantine/core'
import { getPermission } from '../../../../functions/utilFunctions'
import LeadsExport from '../controller/LeadsExport'
import LeadsCopyToList from '../controller/copy/LeadsCopyToList'
import LeadsBulkNewReply from '../controller/LeadsBulkNewReply'
import LeadsBulkTags from '../controller/LeadsBulkTags'
import { useLeadsStore } from '../../../../stores/LeadsStore'
import TableFilterDelete from '../../../../components/TableComponents/TableFilterDelete'
import { deleteProspects } from '../../../../api/PRMAPI'
import LeadsBulkZapier from '../controller/zapier/LeadsBulkZapier'
import LeadsBulkMake from '../controller/make/LeadsBulkMake'
import LeadsEnrichPhone from '../controller/LeadsEnrichPhone'

const TableToolbar = ({ total, rowCount, selectedIds, filter, handleClose, handleLoading, apiRef }) => {
    const setLoadingJobs = useLeadsStore(s => s.setLoadingJobs)

    const handleFinish = () => {
        handleLoading()
        if (apiRef && apiRef.current) {
            apiRef.current.setRowSelectionModel([]);
        }
    }

    return (
        <Stack>
            {getPermission("exportPRM") && (
                <LeadsExport handleClose={handleClose} handleFinish={handleFinish} tableFilter={filter} tableSelection={selectedIds} />
            )}

            <LeadsCopyToList handleClose={handleClose} handleFinish={handleFinish} tableFilter={filter} tableSelection={selectedIds} />

            <LeadsBulkNewReply handleClose={handleClose} handleFinish={handleFinish} tableFilter={filter} tableSelection={selectedIds} />

            <LeadsBulkTags handleClose={handleClose} handleFinish={handleFinish} tableFilter={filter} tableSelection={selectedIds} />

            <LeadsBulkZapier handleClose={handleClose} handleFinish={handleFinish} tableFilter={filter} tableSelection={selectedIds} />

            <LeadsBulkMake handleClose={handleClose} handleFinish={handleFinish} tableFilter={filter} tableSelection={selectedIds} />

            {getPermission("findMobilePhone") && (
                <LeadsEnrichPhone
                    handleClose={handleClose}
                    setLoadingJobs={setLoadingJobs}
                    handleFinish={handleFinish} tableFilter={filter} tableSelection={selectedIds}
                />
            )}

            <TableFilterDelete
                selectedIds={selectedIds}
                filter={filter}
                handleDelete={({
                    ids,
                    excluded_ids,
                    filter
                }) => deleteProspects({ contact_ids: ids, excluded_contact_ids: excluded_ids, filter })}
                apiRef={apiRef}
                onFinish={(type) => {
                    handleLoading(type !== "selection");
                }}
                filterResultNumber={rowCount}
                total={total}
                isPrm
            />
        </Stack>
    )
}

export default TableToolbar